import { render } from "./UpdateBill.vue?vue&type=template&id=0220c132&scoped=true"
import script from "./UpdateBill.vue?vue&type=script&lang=js"
export * from "./UpdateBill.vue?vue&type=script&lang=js"

import "./UpdateBill.vue?vue&type=style&index=0&id=0220c132&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0220c132"]])

export default __exports__